<div class="survey-return">
  <ion-spinner name="lines-small"></ion-spinner>
</div>
